<template>
  <v-layout row justify-center>
    <v-dialog v-model="isOpen" persistent max-width="70rem">
      <v-card>
        <v-card-title class="headline">
          <slot name="header" />
        </v-card-title>
        <v-card-text class="body">
          <slot name="body" />
        </v-card-text>
        <v-card-actions class="btn-group">
          <v-btn class="ok-btn" :disabled="disableOkButton" depressed @click="emitOk">{{
            okBtnText
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    okBtnText: {
      type: String,
      default() {
        return this.$t('actions.ok');
      },
    },
    disableOkButton: {
      type: Boolean,
      default: () => false,
    },
  },

  methods: {
    emitOk() {
      this.$emit('onOk');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.v-card {
  .body.v-card__text {
    font-size: 1.4rem;
    color: $pricing-black;
  }

  .btn-group.v-card__actions {
    justify-content: end;
    padding: 0 0 3rem;

    .ok-btn {
      color: $pricing-white;
      background-color: $btn-ok-color;
      border-color: $btn-ok-color;
      letter-spacing: normal;
      margin-right: 4rem;
    }
  }
}

.v-btn {
  font-size: 1.2rem;
}
</style>
